/* global axios */
import ApiClient from './ApiClient';

// Admin-only Test Inbox: shows the sandbox inbox + its conversations, injects
// messages as a persona, and resets the sandbox.
class TestInboxAPI extends ApiClient {
  constructor() {
    super('test_inbox', { accountScoped: true });
  }

  show() {
    return axios.get(this.url);
  }

  sendMessage({ personaId, content, conversationId }) {
    return axios.post(`${this.url}/send_message`, {
      persona_id: personaId,
      content,
      conversation_id: conversationId,
    });
  }

  // Reply as the current admin (agent side).
  reply({ content, conversationId }) {
    return axios.post(`${this.url}/reply`, {
      content,
      conversation_id: conversationId,
    });
  }

  assign({ conversationId, assigneeId }) {
    return axios.post(`${this.url}/assign`, {
      conversation_id: conversationId,
      assignee_id: assigneeId,
    });
  }

  updateLabels({ conversationId, labels }) {
    return axios.post(`${this.url}/update_labels`, {
      conversation_id: conversationId,
      labels,
    });
  }

  reset() {
    return axios.delete(`${this.url}/reset`);
  }
}

export default new TestInboxAPI();
